import config from "@/config"
import http from "@/utils/request"

export default {
    searchCameraList: {
        url: `${config.API_URL}/qxCamera/device/list`,
        name: "查询设备列表",
        get: async function (data){
            return await http.get(this.url, data);
        }
    },
    addCameraDevice: {
        url: `${config.API_URL}/qxCamera/device/add`,
        name: "添加摄像头设备",
        post: async function (data) {
            /** data: 
             * ChipId      string    chipId(必需)，
             * GBID        string    国标(设备编码)(必需),
             * ModelId     string    型号id(必需),
             * VersionId   string    版本id(必需),
             */
            return await http.post(this.url, data);
        },
    },
    searchModelIdList: {
        url: `${config.API_URL}/qxCamera/model/list`,
        name: "查询型号列表",
        get: async function() {
            return await http.get(this.url);
        } 
    },

    searchVeisionList: {
        url: `${config.API_URL}/qxCamera/version/list`,
        name: "查询版本列表",
        get: async function(data) {
            return await http.get(this.url,data);
        } 
    },
    upgrage:{
        url: `${config.API_URL}/qxCamera/device/batch/prepare/upgrade`,
        name: "批量修改设备升级状态",
        post: async function (data) {
            /** data: 
             * VersionId   string    版本id(必需),
             */
            return await http.post(this.url, data);
        },
    },
    upgrageAll:{
        url: `${config.API_URL}/qxCamera/device/allCamera/upgrade`,
        name: "批量修改当前条件下全部设备升级状态",
        post: async function (data) {
            /** data: 
             * VersionId   string    版本id(必需),
             */
            return await http.post(this.url, data);
        },
    },
    cameraUpgradeLog: {
        url: `${config.API_URL}/qxCamera/upgrade/record/list`,
        name: "查询摄像头升级日志",
        get: async function (data) {
            return await http.get(this.url, data);
        },
    },

    readyUpgradeList: {
        url: `${config.API_URL}/qxCamera/device/readyUpgradeList`,
        name: "待升级列表添加摄像头",
        post: async function (data) {
            return await http.post(this.url, data);
        },
    },
    getReadyUpgradeList :{
        url: `${config.API_URL}/qxCamera/device/readyUpgradeList`,
        name: "查询待升级列表摄像头",
        get: async function (data) {
            return await http.get(this.url, data);
        },
    },
    deleteReadyUpgradeList :{
        url: `${config.API_URL}/qxCamera/device/readyUpgradeList`,
        name: "查询待升级列表摄像头",
        delete: async function (data) {
            return await http.delete(this.url, data);
        },
    },
    postReadyUpgradeList: {
        url: `${config.API_URL}/qxCamera/device/readyUpgradeList/moveUp`,
        name: "待升级列表摄像头升级",
        post: async function (data) {
            return await http.post(this.url, data);
        },
    },
    cancelUpgradeList:{
        url: `${config.API_URL}/qxCamera/device/revokeCameraMoveUp`,
        name: "待升级列表摄像头升级",
        post: async function (data) {
            return await http.post(this.url, data);
        },
    }
    
}
